import { useModelRevisions } from "apis/procore/modelRevisions";

/**
 * True when the scene is a federated model opened from Model Manager (i.e. it
 * resolves to a BIM model revision), false for single Documents/PDM files.
 */
export function useHasModelRevision(): { hasModelRevision: boolean; isLoading: boolean } {
    const { data, isLoading, isFetching } = useModelRevisions();

    return { hasModelRevision: Boolean(data && data.length > 0), isLoading: isLoading || isFetching };
}
